import _ from 'lodash'

class ContactController {
  constructor(http, config) {
   this.user =  {}
   this.http = http
   this.baseUrl = config.contactEndpoint + "/contact"
   this.error = false
   this.success = false
   this.failureMessage =  ''
   this.successMessage = ''
  }

  submit() {
    var that = this
    this.http.post(this.baseUrl,
      { email: this.user.email,
        first: this.user.first,
        last: this.user.last,
        company: this.user.company,
        reason: this.user.reason,
        inquiry: this.user.inquiry
      }).
      then(function(response) {
        that.successMessage = 'Thank you for contacting us! We will get back to you.'
      }, function(response) {
         that.failureMessage =  'Woah! Sorry, there was an error, please try again later.'
    })
  }
}

ContactController.$inject =
  [
    '$http',
    'config'
  ]

export default ContactController
